import { trackInitialPageView } from '@/js/lib/analytics';
import { lazyInit } from '@/js/lib/lazy-init';
import { initActionMenu } from '@/js/modules/action-menu';
import { initAnimate } from '@/js/modules/animate/animate';
import { initBannerHoverVideo } from '@/js/modules/banner-hover-video';
import { initBlogPagesFilter } from '@/js/modules/blog-pages-filter';
import { initCookieConsent } from '@/js/modules/cookie-consent';
import { initCtaVideo } from '@/js/modules/cta-video';
import { initFancybox } from '@/js/modules/fancybox';
import { initHeaderMenu } from '@/js/modules/header-menu';
import { initHeaderScroll } from '@/js/modules/header-scroll';
import { initMobileMenu } from '@/js/modules/mobile-menu';
import { initReviewsBanner } from '@/js/modules/reviews-banner';
import { initScrollStack } from '@/js/modules/scroll-stack';
import { initTabs } from '@/js/modules/tabs';
import { initWebsiteForms } from '@/js/modules/website-form';

trackInitialPageView();

initMobileMenu();
initHeaderMenu();
initHeaderScroll();
initCookieConsent();
initFancybox();
initBannerHoverVideo();
initCtaVideo();
initWebsiteForms();
initReviewsBanner();
initTabs();
initActionMenu();
initBlogPagesFilter();
initScrollStack();
initAnimate();

lazyInit('.js-marquee', async () => {
  (await import('@/js/modules/marquee')).initMarquee();
});

lazyInit('.js-phone-field', async () => {
  (await import('@/js/modules/phone-field')).initPhoneFields();
});

lazyInit('.js-swiper', async () => {
  (await import('@/js/modules/swiper')).initSwiper();
});

lazyInit('.trust', async () => {
  (await import('@/js/modules/trust-popover')).initTrustPopover();
});
